export const en = {
    icon: {
        'SME': 'mdi-factory',
        'MIKRO': 'mdi-account-group'
    },
    msg: {
        // login
        'login': 'Login',
        'username_error_max': 'Please enter your username.',
        'username_error_regex': 'Please enter your username.',
        'password_error_max': 'Please enter your password.',
        'password_error_regex': 'Please enter your password.',
        'error': 'Invalid username or password',
        'blank_username_field': 'Please enter your username.',
        'blank_password_field': 'Please enter your password.',
        'password_error_confirmed': 'Password does not match with new Password.',
        'invalid_credentials': 'Please enter a valid username or password.',
        'copyright': 'Powered by Global Psytech',
        'username_label': 'Username',
        'password_label': 'Password',
        'new_password_label': 'New Password',
        'new_confirm_password_label': 'New Confirm Password',
        'id_number_label': 'ID Number',
        'serverError': 'Sorry, something went wrong. Please try again.',
        'footer_text': 'Global Psytech Sdn. Bhd.',
        'login_button': 'Login',

        // Results Page
        'assessmentDropdownLabel': 'Assessment',
        'sessionDropdownLabel': 'Session',
        'divisionDropdownLabel': 'Division',
        'departmentDropdown': 'Department',
        'registered_employees_text': 'Registered Employees',
        'finished_employees_text': 'Finished',
        'results_page_heading_name': 'Results',
        'filters': 'Filters',
        'table_heading': 'List of Individual Test Report',
        'search': 'Search',
        // Table Headers (Results Page)
        'table_header_name': 'Name',
        'table_header_employeeId': 'Employee Id',
        'table_header_assessment_name': 'Assessment Name',
        'table_header_assessment_session': 'Session',
        'table_header_report': 'Report',
        'table_header_division': 'Division',
        'table_header_department': 'Department',
        'table_header_unit': 'Unit',
        'table_header_option': 'Options',
        'search_placeholder': 'Search',
        // Header
        'logout': 'Logout',
        // SideBar
        'sidebar_text_dashboard': 'Dashboard',
        'sidebar_text_results': 'Results',
        // Loader
        'loading': 'Loading',
        // Table Headers (Growth Profile Page)
        'table_header_gp_date': 'Date',
        'table_header_gp_assessment_name': 'Assessment Name',
        'table_header_gp_programme_name': 'Programme Name',
        'table_header_gp_assessment_session': 'Session',
        'table_header_gp_status': 'Status',
        'table_header_gp_report': 'Reports',
        // Registration error
        'full name (as per nric)_error_required': 'Please enter customers full name as indicated on NRIC.',
        'full name (as per nric)_error_regex': 'Only acceptable characters include letters of the alphabet and special characters such as @ ‘ / - .',
        'full name (as per nric)_error_max': 'The name cannot be longer than 80 characters.',
        'identification number (id)_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'identification number (id)_error_required': 'Please enter NRIC/ passport number.',
        'application id_error_required': 'Please enter customers application ID.',
        'application id_error_max': 'The application ID must not be longer than 15 characters.',
        'application id_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'business registration (br) no_error_required': 'Please enter company’s BR number.',
        'business registration (br) no_error_max': 'The BR number must not be longer than 15 characters.',
        'business registration (br) no_error_alpha_num': 'The only acceptable characters are letters of the alphabet and numerals.',
        'company name_error_required': 'Please enter company’s name.',
        'company name_error_max': 'The company name must not be longer than 80 characters.',
        'company name_error_regex': 'The only acceptable characters are letters of the alphabet, spaces, numerals, and the following special characters: . - & () and ’',
        'business category_error_required': 'Please select company’s business categories.',
        'financing amount requested (rm)_error_required': 'Please enter financing amount.',
        'financing amount requested (rm)_error_numeric': 'This entry can only contain numbers.',
        'financing tenure_error_required': 'Please enter financing tenure.',
        'financing tenure_error_min_value': 'The tenure amount requested must be at least 10.',
        'financing tenure_error_max_value': 'The tenure amount must not exceed 120.',
        'programme applied_error_required': 'Please select programme applied.',
        'facility applied_error_required': 'Please select facility applied.',
        'region_error_required': 'Please select region.',
        'orr_error_required': 'Please enter ORR.',
        'orr_error_numeric': 'The only acceptable characters are letters of the alphabet and numerals.',
        'financing amount_error_required': 'Please enter financing amount.',
        'financing amount_error_numeric': 'This entry can only contain numbers.',
        'email_error_required': 'Please enter email address.',
        'email_error_email': 'Please enter a valid email address.',
        'sms_error_required': 'Please Enter Mobile Number',
        'sms_error_numeric': 'Please enter a valid Mobile Number',
        'scheme_error_required': 'Please select the product you are applying.',
        'branch_error_required': 'Please select a CGC branch that you are dealing with.',
        'business_registration_number_error_required': 'Please enter your company’s BR number.',
        'businesscategory_error_required': 'Please select Business Category',
        'currency_error_required': 'Please select the Preferred Currency',
        'typeofbusiness_error_required': 'Please select type of Business',

        'otherEthnicity_error_required': 'Please provide customers ethnicity',
        'companyName_error_required': 'Please enter company name',
        'officerName_error_required': 'Please enter officer name',
        'officerId_error_required': 'Please enter officer id',
        'businessCategory_error_required': 'Please select business category',
        'gender_error_required': 'Select gender',
        'applicationNumber_error_required': 'Please enter application number',

        // Login
        'username_error_required': 'Please enter your username',
        'password_error_required': 'Please enter your password',

        // Dashboard
        'export_button': 'Export',

        // Headers
        'sl_no': 'No.',
        'verification_code': 'Verification Code',
        'br_number': 'Business Registration (BR)No.',
        'company_name': 'Company Name',
        'id_number': 'Identification Number (ID)',
        'business_category': 'Business Category',
        'staff_id_number': 'Staff ID No.',
        'branch': 'Branch',
        'scheme': 'Product',
        'financing_amount_requested': 'Financing Amount Requested',
        'tenureApplied': 'Tenure Applied',
        'gfi_status': 'GFI Status',
        'gfi_completion_date': 'GFI Completion Date',
        'update_details': 'Update Details',
        'gfi_scoring': 'GFI Scoring',
        'application_status': 'Application Status',
        'report': 'Report',
        'expiry_date': 'Expiry Date',
        'f1': 'F1',
        'f2': 'F2',
        'f3': 'F3',
        'gfi_rating': 'GFI Rating',

        // Dropdowns
        'scheme_label': 'Product',
        'amountRange_label': 'Financing Amount Range',
        'gfiStatus_label': 'GFI Status',
        'applicationStatus_label': 'Financing Application Status',
        'start_date_label': 'Start Date',
        'end_date_label': 'End Date',
        'branch_label': 'Branch',
        'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support',
        'export_unavailable': 'We encountered an error while exporting data , please try again.<br>If the problem persists please contact support',
        'close_label': 'Close',
        'customer_application_status_error_required': 'Please select the application status',

        // Applied filters
        'scheme_all_applied':'All Products',
        'amountRange_all_applied':'All Financing Amount Ranges',
        'gfiStatus_all_applied':'All GFI Status',
        'applicationStatus_all_applied':'All Financing Application Status',
        'all_dates':'All Dates',
        'end_date':'Start Date',
        'start_date':'End Date',

        //Score generation
        'product_applied': 'Product Applied',

        // TimeOut Dialog
        'session_expire_heading': 'Session Expiration Warning',
        'session_expire_message_1': 'Your session will expire in',
        'session_expire_message_2': 'seconds. Please click “Continue” to continue your session or click “Log Out Now” to end your session now.',

        'table_heading_export': 'Data Export History',
        'table_header_no': 'Sl No.',
        'table_header_date': 'Export Date',
        'table_header_finance_type': 'Finance Type',
        'table_header_filter_applied': 'Filters Applied',
        'table_header_status': 'Status',
        'table_header_download': 'Download',

        'date_error_required': 'Select a date',

        // edit customer

        'paidUpCapital_error_numeric': 'Numeric value only',
        'paidUpCapital_error_min_value': 'The minimum amount should be greater than 0',
        'paidUpCapital_error_max_value': 'The maximum amount should not be greater than 999999999',

        'business_size_error_required': 'Select an option',
        'nature_of_business_error_required': 'Select an option',

        'industryExperience_error_required': 'Specify a number',
        'industryExperience_error_min_value': 'The minimum value should be greater than 0',
        'industryExperience_error_max_value': 'The maximum value should not be greater than 180',
        'industryExperience_error_numeric': 'Numeric values only',

        'employeesCount_error_required': 'Please enter number of employees',
        'employeesCount_error_numeric': 'Numeric values only',
        'employeesCount_error_min_value': 'The minimum value should be greater than 0',
        'employeesCount_error_max_value': 'The maximum value should not be greater than 1000',

        'annualSales_error_integer': 'Please enter a valid amount',
        'annualSales_error_required': 'Specify amount',
        'annualSales_error_min_value': 'The minimum amount should be greater than -999999999',
        'annualSales_error_max_value': 'The maximum amount should not be greater than 999999999',
        'annualSales_error_numeric': 'Numeric values only',

        'annualProfit_error_integer':'Please enter a valid amount',
        'annualProfit_error_required':'Specify amount',
        'annualProfit_error_min_value':'The minimum amount should be greater than -999999999',
        'annualProfit_error_max_value':'The maximum amount should not be greater than Annual Sales Turnover.',
        'annualProfit_error_numeric': 'Numeric values only',

        'financingAmount_error_required':'Specify amount',
        'financingAmount_error_min_value':'The minimum amount should be greater than {0}',
        'financingAmount_error_max_value':'The maximum amount should not be greater than {1}',
        'financingAmount_error_numeric': 'Numeric values only',

        'tenureApplied_error_required':'Specify a number',
        'tenureApplied_error_min_value':'The minimum value should be greater than {0}',
        'tenureApplied_error_max_value':'The maximum value should not be greater than {1}',
        'tenureApplied_error_numeric': 'Numeric values only',

        'financingAmountApproved_error_required': 'Specify amount',
        'financingAmountApproved_error_min_value':'The minimum amount should be greater than 0',
        'financingAmountApproved_error_max_value':'The maximum amount should not be greater than 999999999',
        'financingAmountApproved_error_numeric': 'Only numeric values are accepted',

        'tenureApproved_error_required': 'Specify a number',
        'tenureApproved_error_min_value':'The minimum value should be greater than 0',
        'tenureApproved_error_max_value':'The maximum value should not be greater than 180',
        'tenureApproved_error_numeric': 'Numeric values only',
        
        'internalRating_error_required': 'Please enter internal credit rating of the customer.',
        'internalRating_error_numeric': 'Numeric values only',
        'internalRating_error_min_value': 'The minimum value should be greater than 0',
        'internalRating_error_max_value': 'The maximum value should not be greater than 100',

        'cbrRating_error_required': 'Please enter Credit Bureau Rating of the customer.',
        'cbrRating_error_numeric': 'Numeric values only',
        'cbrRating_error_min_value': 'The minimum value should be greater than 250',
        'cbrRating_error_max_value': 'The maximum value should not be greater than 900',

        'applicationNumber_error_alpha_num': 'Alphabets and Numbers only',
        'applicationNumber_error_max': 'The maximum value should not be greater than 20',
        'applicationNumber_error_0': 'Application Number already exists',

        'asterisk_remark': '- This field is required to be filled in order to generate GFI scores',
    }
}
